import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Zone.js must be loaded after any dependency that might overwrite `window.Promise`.
// Some bundles (notably ExcelJS) can inject/replace a Promise implementation during module init.
declare const require: any;
require('zone.js/dist/zone');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
